module.exports = __webpack_public_path__ + "img/product11.4757b8e6.png";